import { useParams } from 'react-router-dom';

import RepositoriesOverview from '../../features/repositories/layouts/overview';
import CreateRepositoryForm from '../../features/repositories/forms/create';
import EditRepositoryForm from '../../features/repositories/forms/edit';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
//   /admin/repositories      → the list, with its filters in the query string
//   /admin/repositories/new  → the create form
//   /admin/repositories/:id  → the edit form, with environments and deployments

export default function RepositoriesPage({ mode }) {
    const { id } = useParams();

    if (mode === 'create' || id === 'new') return <CreateRepositoryForm />;
    if (id) return <EditRepositoryForm repositoryId={id} />;
    return <RepositoriesOverview />;
}
